<template>
  <div class="footer">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-xl-6 col-md-6">
          <div class="copy_right">
            Copyright © {{ new Date().getFullYear() }} OTC919. All Rights
            Reserved.
          </div>
        </div>
        <div class="col-xl-6 col-md-6 text-lg-right text-center">
          <div class="social">
            <!-- <a href="#"><i class="fa fa-youtube-play"></i></a> -->
            <a href="https://t.me/otc919" target="blank"
              ><i class="fa fa-telegram"></i
            ></a>
            <a href="https://btok360.com/otc919" target="blank"
              ><i class="fa fa-twitter"></i
            ></a>
            <!-- <a href="#"><i class="fa fa-twitter"></i></a>
            <a href="#"><i class="fa fa-facebook"></i></a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>
